export default "__VITE_ASSET__Dwa57o0g__"